import React from "react";
import moment from "moment";
import "./WantAdExpiryNote.scss";

export const SHOW_WITHIN_DAYS = 14;
export const URGENT_WITHIN_DAYS = 7;

const parseExpiry = (value) => {
  if (!value) return null;
  const parsed = moment.utc(value);
  return parsed.isValid() ? parsed : null;
};

export const daysUntilExpiry = (value, now = moment.utc()) => {
  const expiry = parseExpiry(value);
  if (!expiry) return null;
  return expiry.clone().local().startOf("day").diff(moment(now).local().startOf("day"), "days");
};

export const expiryNote = (value, now = moment.utc()) => {
  const days = daysUntilExpiry(value, now);
  if (days === null || days > SHOW_WITHIN_DAYS) return null;
  const urgent = days <= URGENT_WITHIN_DAYS;
  if (days < 0) return { text: "Moves to Expired soon", urgent };
  if (days === 0) return { text: "Expires today", urgent };
  if (days === 1) return { text: "Expires tomorrow", urgent };
  if (urgent) return { text: `Expires in ${days} days`, urgent };
  return { text: `Expires ${parseExpiry(value).local().format("MMM D")}`, urgent };
};

export const isExpiringSoon = (value, now) => {
  const days = daysUntilExpiry(value, now);
  return days !== null && days <= URGENT_WITHIN_DAYS;
};

const WantAdExpiryNote = ({ expiryDate }) => {
  const note = expiryNote(expiryDate);
  if (!note) return null;
  return (
    <span className={`want-ad-expiry-note${note.urgent ? " is-urgent" : ""}`}>
      {note.text}
    </span>
  );
};

export default WantAdExpiryNote;
